import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectSignedIn } from "reducers/auth";
import { IoMdCart } from "react-icons/io";
import ShoppingCart, { ShoppingCartRef } from "../../ShoppingCart/ShoppingCart";
import { getTotalItemCount } from "../../ShoppingCart/ShoppingCart.utils";
import { useCart, CartProvider } from "../../ShoppingCart/CartContext";
import "./ShoppingCartIcon.scss";

type ShoppingCartIconProps = {
  // Simple button component for now
};

const ShoppingCartIconContent: React.FC<ShoppingCartIconProps> = () => {
  const isSignedIn = useSelector(selectSignedIn);
  const accessToken = localStorage.getItem("AT");
  const cartRef = useRef<ShoppingCartRef>(null);
  const { items, refreshCart, toggleCart } = useCart();

  const numberOfItemsInCart = getTotalItemCount(items);

  // Refresh cart when component mounts and when user signs in
  useEffect(() => {
    if (isSignedIn && accessToken) {
      refreshCart();
    }
  }, [isSignedIn, accessToken, refreshCart]);

  const handleIconClick = () => {
    if (!isSignedIn || !accessToken) return;
    cartRef.current?.toggle();
  };

  if (!isSignedIn) return null;

  return (
    <div className="ShoppingCartIconContainer">
      <div className="ShoppingCartIcon" data-testid="cart-icon" onClick={handleIconClick}>
        {IoMdCart({ size: 25 })}
        {numberOfItemsInCart > 0 && (
          <span className="NumOfItemsInCart" data-testid="cart-badge">
            {numberOfItemsInCart}
          </span>
        )}
      </div>

      <ShoppingCart ref={cartRef} />
    </div>
  );
};

const ShoppingCartIcon: React.FC<ShoppingCartIconProps> = () => {
  return <ShoppingCartIconContent />;
};

export { ShoppingCartIcon };
